import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../../components/button";
import { useLanguage } from "@languages/index";
import { MessageCard } from "./MessageCard";
import * as modalAction from "../../store/modal/actions";
import API from "../../api";
import { useSelector } from "react-redux";

interface PropTypes {
  handleOpenAppealReels: (params: {
    url: string;
    type: "CAMPAIGN" | "AMBASSADOR";
    applicantId: number;
  }) => void;
  type: "CAMPAIGN" | "AMBASSADOR";
  isInfluencersPage: boolean;
  canModifyInfluncerMessage?: boolean;
  users: any[];
  setListData?: React.Dispatch<React.SetStateAction<any[]>>;
  campaignData:any;
  productId:string;
  nextStep?: () => void;
  title?: string;
}

export const InfluencerMessageModal = ({
  handleOpenAppealReels,
  type,
  isInfluencersPage,
  canModifyInfluncerMessage,
  users,
  setListData,
  campaignData,
  productId,
  nextStep,
  title
}: PropTypes) => {
  const dispatch = useDispatch();
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.component.modelCard,
  };

  const brandToken = useSelector((state) => state?.auth?.auth?.token);

  const campaignId = campaignData?.id;



  const modalTitle = useMemo(()=>{
    if(title){
      return title;
    }
    return !!canModifyInfluncerMessage ? languageTexts.message_modal_title : languageTexts.message_modal_title_not_modify
  },[])

  const closeModal = () => {
    dispatch(modalAction.closeModal());
  };

  const initialMessages = useMemo(()=>{
    return users.map((user)=>{
      return {
        applicantId: user.application.id,
        message: user.application.influencerMessage,
      }
    })
  },[users])


  const [messages, setMessages] = useState<{applicantId: number, message: string}[]>(initialMessages);


 const handleMessageChange = useCallback((applicantId, meesage)=>{

  setMessages((prev)=>{
    const hasApplicantId = prev.find((item)=>item?.applicantId === applicantId);
    if(hasApplicantId){
      return prev.map((item)=>{
        if(item.applicantId === applicantId){
          return {
            ...item,
            message: meesage,
          }
        }
        return item;
      })
    }
    return [...prev, { applicantId :applicantId, message: meesage }];
  });
 },[setMessages])

  const handleSubmit = useCallback(async() => {

    try {
    await API.Campaign.patchInfluencerMessage({
      brandToken: brandToken,
      campaignId: campaignId,
      productId: productId,
      messages: messages,
    })
    const messageApplicantIds = messages.map((item)=>item.applicantId);
    setListData?.((prev) => {
     return prev.map((item)=>{
      
      if(messageApplicantIds?.includes(item.id)){
        return {
          ...item,
          influencerMessage: messages.find((messageItem)=>messageItem.applicantId === item.id)?.message || "",
        }
      }
      return item;
     })
    })
    } catch (error) {
      console.log('MESSAGE UPDATE ERROR : ',error)
    }finally{
    closeModal();
    nextStep?.();
        }
    
  },[setListData,messages])


  return (
    <div className="flex flex-col bg-white p-10 md:w-[460px]">
      <div className="flex flex-col gap-5">
        <div className="title">
          <span className="text-xl font-bold">
            {modalTitle}
          </span>

          <div className="mb-[30px]">
            <span className="text-sm text-[red]">
              {languageTexts.message_modal_desc}
            </span>
          </div>

          {users.map((user, index) => (
            <React.Fragment key={user.id}>
            <MessageCard
              key={user.id}
              languageTexts={languageTexts}
              application={user.application}
              handleOpenAppealReels={handleOpenAppealReels}
              type={type}
              canModifyInfluncerMessage={!!canModifyInfluncerMessage}
              isInfluencersPage={isInfluencersPage}
              user={user}
              messages={messages}
              handleMessageChange={handleMessageChange}
            />
            {users?.length > 1 && index !== users.length - 1 && <div className="border-t border-[#E8E8E8] my-[30px]" />}
            </React.Fragment>
          ))}
        </div>

        <div className="flex flex-col">
          <Button
            text={languageTexts.message_modal_comfirm}
            textColor="WHITE"
            buttonColor="BLACK"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};
